import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { Modal, Table } from '@iwoca/orion';
import { FormattedDate, useIntl } from 'react-intl';
import messages from './flexiScheduleModal.messages';
import { ColumnDef } from '@iwoca/orion/lib/components/table/Table';
import styles from './flexiScheduleModal.module.css';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

type TSchedule = NonNullable<
    GetDrawDownRepaymentScheduleCreditFacilityResponse['data']
>['schedule'][number];

const FlexiScheduleModal = ({
    schedule,
    isOpen,
    onClose
}: {
    schedule: TSchedule[];
    isOpen: boolean;
    onClose: () => void;
}) => {
    const intl = useIntl();

    const columns: ColumnDef<TSchedule>[] = [
        {
            accessorKey: 'date',
            header: intl.formatMessage(messages.dateHeader),
            cell: (info) => <FormattedDate value={info.cell.getValue()} />
        },
        {
            accessorKey: 'interest',
            header: intl.formatMessage(messages.interestHeader),
            cell: (info) => <FormattedCurrency value={info.cell.getValue()} />
        },
        {
            accessorKey: 'principal',
            header: intl.formatMessage(messages.principleHeader),
            cell: (info) => <FormattedCurrency value={info.cell.getValue()} />
        },
        {
            accessorKey: 'total',
            header: intl.formatMessage(messages.totalHeader),
            cell: (info) => <FormattedCurrency value={info.cell.getValue()} />
        }
    ];

    return (
        <Modal
            className={styles.modal}
            isOpen={isOpen}
            onClose={onClose}
            title={intl.formatMessage(messages.title)}
            closeIcon
            data-testid="flexiScheduleModal"
        >
            <Table columns={columns} data={schedule} maxHeight={400} />
        </Modal>
    );
};

// eslint-disable-next-line import/no-default-export
export default FlexiScheduleModal;
